import { useQuery } from '@tanstack/vue-query'
import { getKycStatus } from '../profileEndpoints'
import { profileKeys } from '../profileQueryKeys'

export function useKycStatusQuery() {
  return useQuery({
    queryKey: profileKeys.kycStatus(),
    queryFn: getKycStatus,
  })
}
